import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Footer.css';
import { Link, useLocation } from 'react-router-dom';
import { SITE_LANGUAGE_LANDINGS } from '../../data/siteLanguages';
import { ASTRO_LINKS, SPREAD_LINKS } from '../../data/siteNav';
import { chartHref, languageFromPath } from '../../data/chartLanguage';
import { LEARN_TAROT_ENABLED } from '../../pages/LearnTarot/learnData';

function withChartLang(link, lang) {
  if (link.to === '/birth-chart/' || link.to === '/birth-chart-compatibility/') {
    return chartHref(link.to, lang);
  }
  return link.to;
}

const Footer = () => {
  const { user } = useAuth();
  const pageLang = languageFromPath(useLocation().pathname);

  const openLiveChat = () => {
    window.dispatchEvent(new CustomEvent('nowtarot:open-chat'));
  };

  return (
    <>
      {user && (
        <div className="support-line">
          <p>Need help? <Link
            to="/support"
            style={{ color: 'inherit', textDecoration: 'underline', padding: '0 4px' }}
            onClick={() => window.scrollTo(0, 0)}
          >
            Send us a message
          </Link></p>
        </div>
      )}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-columns">
            <nav className="footer-column" aria-label="Tarot readings">
              <p className="footer-heading">Free readings</p>
              <ul>
                {SPREAD_LINKS.map((link) => (
                  <li key={link.to}><a href={withChartLang(link, pageLang)} className="footer-link">{link.label}</a></li>
                ))}
              </ul>
            </nav>
            <nav className="footer-column" aria-label="Astrology">
              <p className="footer-heading">Free astrology</p>
              <ul>
                {ASTRO_LINKS.map((link) => (
                  <li key={link.to}><a href={withChartLang(link, pageLang)} className="footer-link">{link.label}</a></li>
                ))}
              </ul>
            </nav>
            <nav className="footer-column" aria-label="Learn tarot">
              <p className="footer-heading">Learn tarot</p>
              <ul>
                {LEARN_TAROT_ENABLED && <li><a href="/learn-tarot/" className="footer-link">Learn Tarot Guides</a></li>}
                <li><a href="/tarot-card-meanings/" className="footer-link">Tarot Card Meanings</a></li>
                <li><a href="/card-of-the-day/" className="footer-link">Tarot Card of the Day</a></li>
                <li><a href="/how-it-works/" className="footer-link">How AI Tarot Works</a></li>
                <li><a href="/es/significados-cartas-tarot/" className="footer-link" lang="es">Significados del tarot</a></li>
                <li><a href="/ar/tarot-card-meanings/" className="footer-link" lang="ar" dir="rtl">معاني بطاقات التاروت</a></li>
                <li><a href="/zh/taluo-pai-yisi/" className="footer-link" lang="zh">塔罗牌含义</a></li>
                <li><a href="/de/tarot-kartenbedeutungen/" className="footer-link" lang="de">Tarotkarten-Bedeutungen</a></li>
                <li><a href="/pl/znaczenia-kart-tarota/" className="footer-link" lang="pl">Znaczenia kart tarota</a></li>
                <li><a href="/pt/significados-cartas-tarot/" className="footer-link" lang="pt">Significados do tarô</a></li>
                <li><a href="/fr/significations-cartes-tarot/" className="footer-link" lang="fr">Significations du tarot</a></li>
              </ul>
            </nav>
            <nav className="footer-column" aria-label="Ask Tarot AI">
              <p className="footer-heading">Ask Tarot AI</p>
              <ul>
                <li><a href="/ask-an-ai/" className="footer-link">Ask Tarot AI</a></li>
                <li><a href="/ai-psychic/" className="footer-link">Free AI Psychic</a></li>
                <li><button type="button" className="footer-link footer-chat-link" onClick={openLiveChat}>Ask in live chat</button></li>
              </ul>
            </nav>
            <nav className="footer-column" aria-label="Legal">
              <p className="footer-heading">NowTarot</p>
              <ul>
                <li><a href="/terms/" className="footer-link">Terms of Service</a></li>
                <li><a href="/privacy/" className="footer-link">Privacy Policy</a></li>
              </ul>
            </nav>
          </div>
          <nav className="footer-languages" aria-label="Language pages">
            <p className="footer-heading">AI tarot in your language</p>
            <ul>
              {SITE_LANGUAGE_LANDINGS.map((language) => (
                <li key={language.path}>
                  <a
                    href={language.path}
                    className="footer-link"
                    lang={language.code}
                    dir={language.code === 'ar' ? 'rtl' : undefined}
                  >
                    {language.seoLinkLabel}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <p className="disclaimer" data-nosnippet>
            NowTarot is an entertainment service. All readings, predictions, and insights are intended for fun and personal reflection only and are not a substitute for professional advice.
          </p>
          <p className="copyright">
            © {new Date().getFullYear()} NowTarot. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
